// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb-category-card":"categoryBreadcrumb_breadcrumb-category-card__8vwiG"};